import React, { memo, useEffect } from "react";
import { Stack, Divider } from "investira.react.components";
import PlanoPosicao from "../PlanoPosicao";
import Highlights from "./Highlights";
import Secoes from "./Secoes";
import Graphs from "./Graphs";
import ConsultaProvider from "../../../../contexts/ConsultaContext";
import useKickBack from "../../../../hooks/useKickBack";
import withMessage from "../../../../hoc/withMessage";

const ConsultaEnquadramento = memo((props) => {
  const { data } = props;
  const kick = useKickBack();

  useEffect(() => {
    kick && props.onMessage("Entidade alterada");
  }, [kick]);

  return (
    <ConsultaProvider>
      <Stack spacing={2}>
        <PlanoPosicao
          beta={false}
          created={data.request?.data}
          carteira={data.request_metadata?.carteira}
          enquadramento={data.request_metadata?.enquadramento}
          consolidacao={data.request_metadata?.consolidacao}
        />
        <Divider />
        <Stack
          sx={{ gap: 2 }}
          component="section"
          direction={{ xs: "column", md: "row" }}
        >
          <Stack
            sx={{
              flex: { xs: 1, md: 3, xl: 2 },
              minHeight: 0,
            }}
          >
            <Highlights data={data} />
          </Stack>
          <Stack
            sx={{
              flex: { xs: 1, md: 5, xl: 5 },
              minHeight: 0,
            }}
          >
            <Graphs data={data} />
          </Stack>
        </Stack>
        <Secoes data={data} />
      </Stack>
    </ConsultaProvider>
  );
});

export default withMessage(ConsultaEnquadramento);
